module.exports = __webpack_public_path__ + "img/fav.bcc5dfc5.svg";